import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bxl-view-2d-ai-assessment',
  templateUrl: 'view-2d-ai-assessment.component.html',
})
export class View2DAiAssessmentComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {

  }

}
